let counters = {};

const getCounter = (key) => counters[key];

const getNextCounter = (key) => (counters[key] = (counters[key] || 0) + 1);

const resetCounters = () => {
    counters = {};
};

export {getCounter, getNextCounter, resetCounters};
